import { FlexProps, Link } from 'pounceV2';
import React from 'react';
import { NavLinkBaseProps } from '../types';
import NavLinkContentV3 from './NavLinkContentV3';

type NavLinkExternalProps = NavLinkBaseProps & {
  href: string;
};

const NavLinkExternalV3 = ({
  icon,
  label,
  href,
  isSecondary,
  ...flexProps
}: NavLinkExternalProps & FlexProps) => {
  return (
    <Link external href={href}>
      <NavLinkContentV3 icon={icon} label={label} isSecondary={isSecondary} {...flexProps} />
    </Link>
  );
};

export default NavLinkExternalV3;
